import {
  updateSettings,
  sendEmail,
} from "@/services/api/app/settings";
import settingsRecipients from "@/store/app/entraId/settings/settings";

const defaultState = () => ({
  settings: null,
  providerType: 6,
})

export default {
  namespaced: true,

  actions: {
    updateSettings({commit, state}, settingsForm) {
      return updateSettings(settingsForm, state.providerType)
        .then((result) => {
          commit('setSettings', result)
          return result
        })
    },

    sendEmail({commit, dispatch}) {
      return sendEmail(6);
    },
  },

  mutations: {
    setSettings(state, settings) {
      state.settings = settings
    },
  },

  getters: {},

  state: defaultState(),

  modules: {
    settingsRecipients,
  }
}
